// React Query keys for the ops rota. Everything hangs off `all`, so one
// invalidation after a write refreshes the calendar, the day panel, the
// preview and the dashboard bar together. Each key ends with the agency the
// call is scoped to, so the first answer after the shell resolves its
// agency is fetched again rather than served from an unscoped cache.
type Agency = number | null;

export const opsRotaQueryKeys = {
  all: ['ops_rota'] as const,
  onDuty: (timeZone: string, agencyId: Agency = null) =>
    ['ops_rota', 'on_duty', timeZone, agencyId] as const,
  schedules: (
    from: string,
    to: string,
    {
      carryOver = false,
      agencyId = null,
    }: { carryOver?: boolean; agencyId?: Agency } = {},
  ) => ['ops_rota', 'schedules', from, to, carryOver, agencyId] as const,
  managers: (agencyId: Agency = null) =>
    ['ops_rota', 'managers', agencyId] as const,
  managersAll: (agencyId: Agency = null) =>
    ['ops_rota', 'managers', 'all', agencyId] as const,
};
